import { useEffect } from 'react';
import Card from '../Card';
import Button from '../Button';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, AppDispatch } from '../../store';
import { fetchInvoices } from '../../store/features/billing/billingSlice';

const Title = styled.h3`margin: 0 0 .6rem; font-weight: 800; color: #E8EAED;`;
const Muted = styled.p`margin: 0 0 1rem; color: #9AA4B2;`;

// Optional: compact button style for table actions
const CompactButton = styled(Button)`
  padding: 4px 10px;
  font-size: 0.85rem;
  line-height: 1.1;
`;

export default function BillingHistoryTable() {
  const dispatch = useDispatch<AppDispatch>();
  const { invoices, loading } = useSelector((s: RootState) => s.billing);

  useEffect(() => { dispatch(fetchInvoices()); }, [dispatch]);

  return (
    <Card>
      <Title>Billing history</Title>
      <Muted>Recent invoices and receipts.</Muted>

      {loading && <div>Loading…</div>}
      {!loading && invoices.length === 0 && <div>No invoices yet.</div>}

      {invoices.length > 0 && (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={{ textAlign: 'left', padding: '8px' }}>Date</th>
                <th style={{ textAlign: 'left', padding: '8px' }}>Description</th>
                <th style={{ textAlign: 'left', padding: '8px' }}>Amount</th>
                <th style={{ textAlign: 'left', padding: '8px' }}>Status</th>
                <th style={{ textAlign: 'left', padding: '8px' }}>Invoice</th>
              </tr>
            </thead>
            <tbody>
              {invoices.map(inv => {
                const when = new Date(inv.created * 1000).toLocaleDateString();
                const amt = (inv.amount_due / 100).toFixed(2);
                const desc = (inv as any)?.lines?.data?.[0]?.description || 'Subscription';

                const openUrl = (url: string | null | undefined) => {
                  if (url) window.open(url, '_blank', 'noopener,noreferrer');
                };

                return (
                  <tr key={inv.id} style={{ borderTop: '1px solid rgba(255,255,255,.08)' }}>
                    <td style={{ padding: '8px' }}>{when}</td>
                    <td style={{ padding: '8px' }}>{desc}</td>
                    <td style={{ padding: '8px' }}>${amt}</td>
                    <td style={{ padding: '8px', textTransform: 'capitalize' }}>{inv.status}</td>
                    <td style={{ padding: '8px' }}>
                      {inv.invoice_pdf ? (
                        <CompactButton onClick={() => openUrl(inv.invoice_pdf)}>
                          PDF
                        </CompactButton>
                      ) : inv.hosted_invoice_url ? (
                        <CompactButton onClick={() => openUrl(inv.hosted_invoice_url)}>
                          View
                        </CompactButton>
                      ) : (
                        'n/a'
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
}
